module.exports = __webpack_public_path__ + "static/media/panel.dfeefe49.png";